import { render } from "./structure_table.vue?vue&type=template&id=3a512256&scoped=true"
import script from "./structure_table.vue?vue&type=script&lang=js"
export * from "./structure_table.vue?vue&type=script&lang=js"

import "./structure_table.vue?vue&type=style&index=0&id=3a512256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a512256"]])

export default __exports__